<template>
  <div :class="visible?'tk-search-tab cur':'tk-search-tab'">
    <div class="main-box">
      <a href="javascript:" class="close" @click="()=>{this.$emit('advHideSearch')}"></a>
      <div class="tabs">
        <span :class="tabIndex===1?'cur':''" @click="changeTab(1)">
        <em>高级检索</em>
        </span>
        <span :class="tabIndex===2?'cur':''" @click="changeTab(2)">
        <em>简单检索</em>
        </span>
      </div>
      <div class="tab-content">
        <book v-if="tabIndex===1" :isParentSearch="isParentSearch" @advancedsearch2="advancedsearch2" />
        <knowledge v-if="tabIndex===2" :isParentSearch="isParentSearch" @simpleSearch2="simpleSearch2" />
      </div>
    </div>
  </div>
</template>
<script>
import book from "./tabs/book";
import knowledge from "./tabs/knowledge";

export default {
  props: {
    visible: {
      required: true,
    },
    isParentSearch:{
        detail:false
    }
  },
  data() {
    return {
      tabIndex: 1,
    };
  },
  watch: {
    
  },

  computed: {
  },

  components: {
    book,
    knowledge,
  },

  mounted() {
  },

  methods: {
    changeTab(index) {
      this.tabIndex = index;
      // 向父组件（book.vue）传值
      this.$emit('getTabIndex', this.tabIndex);
    },
    simpleSearch2(params){ // 列表页(searchResult)简单检索
      this.$emit('simpleSearch2', params);
    },
    advancedsearch2(params){ // 列表页(searchResult)高级检索
      this.$emit('advancedsearch2', params);
    }
  },
};
</script>
